import { render, staticRenderFns } from "./pages4.vue?vue&type=template&id=5a3e42e0&scoped=true&"
import script from "./pages4.vue?vue&type=script&lang=js&"
export * from "./pages4.vue?vue&type=script&lang=js&"
import style0 from "./pages4.vue?vue&type=style&index=0&id=5a3e42e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e42e0",
  null
  
)

export default component.exports